import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import type { W_FieldReportAssignmentHistory_FindForFieldReport_VM } from 'ab-api/web/fieldReportAssignmentHistory/findForFieldReport/viewModel';

import type TimeZoneSourceType from 'ab-enums/timezoneSourceType.enum';

import * as FieldReportAssignmentHistoryActons from 'af-actions/fieldReportAssignmentHistory';

import Modal from './Modal';

interface OwnProps {
	workOrderId: number;
	woCode: string;
	showModal: boolean;
	closeModal: () => void;
	timeZoneInUse: Nullable<string>;
	timezoneSourceType: Nullable<TimeZoneSourceType>;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const FieldReportAssignmentHistoryModal: React.FC<Props> = (props: Props) => {

	const {
		workOrderId,
		woCode,
		showModal,
		closeModal,
		findAssignmentHistoryForFieldReport,
		timeZoneInUse,
		timezoneSourceType,
	} = props;

	const [assigmentHistoryRows, setAssigmentHistoryRows] = React.useState<W_FieldReportAssignmentHistory_FindForFieldReport_VM[]>([]);
	const [isLoading, setIsLoading] = React.useState(false);

	React.useEffect(() => {
		if (showModal) {
			setIsLoading(true);
			fetchRows(workOrderId, findAssignmentHistoryForFieldReport);
		} else {
			setAssigmentHistoryRows([]);
		}
	}, [findAssignmentHistoryForFieldReport, showModal, workOrderId]);

	return (
		<Modal
			assigmentHistoryRows={assigmentHistoryRows}
			closeModal={closeModal}
			isLoading={isLoading}
			showModal={showModal}
			timeZoneInUse={timeZoneInUse}
			timezoneSourceType={timezoneSourceType}
			woCode={woCode}
		/>
	);

	async function fetchRows(_workOrderId: number, fetch: (id: number) => Promise<W_FieldReportAssignmentHistory_FindForFieldReport_VM[]>) {
		const rows = await fetch(_workOrderId);
		setAssigmentHistoryRows(rows);
		setIsLoading(false);
	}
};

function mapDispatchToProps() {
	return {
		findAssignmentHistoryForFieldReport: FieldReportAssignmentHistoryActons.findAssignmentHistoryForFieldReport,
	};
}

const connector = connect(null, mapDispatchToProps());

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(FieldReportAssignmentHistoryModal);
